export const formatToIndianCurrency = (value) => {
  return value
    .toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    })
    .replace("₹", "₹ ");
};

/**
 * Short Indian form used on the portfolio cards, e.g. 15000000 -> "₹ 1.5 crore".
 * Falls back to full grouping below a lakh. Tolerates null/undefined, which the
 * plain formatter above does not.
 */
export const formatToIndianShortCurrency = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";

  const trim = (num) => `${Number(num.toFixed(2))}`;

  if (Math.abs(amount) >= 10000000) {
    return `₹ ${trim(amount / 10000000)} crore`;
  }
  if (Math.abs(amount) >= 100000) {
    return `₹ ${trim(amount / 100000)} lakh`;
  }
  return formatToIndianCurrency(amount);
};
